import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { events } from "@/mocks/events";

export default function Hero() {
  const navigate = useNavigate();
  const [term, setTerm] = useState("");

  const hotTags = ["顶流生图", "恋综名场面", "音乐节合唱", "带货翻车", "公益直播"];

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(term.trim() ? `/events?q=${encodeURIComponent(term.trim())}` : "/events");
  };

  return (
    <section className="relative flex min-h-[560px] w-full items-center overflow-hidden pt-16 md:min-h-[640px] md:pt-20">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20artistic%20abstract%20collage%20of%20trending%20news%20and%20entertainment%20elements%20with%20playful%20pop%20culture%20vibe%2C%20stylized%20fire%20and%20sparkles%20over%20warm%20orange%20amber%20and%20cream%20tones%2C%20newspaper%20texture%2C%20cinematic%20golden%20light%2C%20vibrant%20yet%20soft%20editorial%20background%2C%20no%20text&width=1600&height=900&seq=gua-hero&orientation=landscape"
        alt="国产吃瓜视频热点速递背景图"
        className="absolute inset-0 h-full w-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80"></div>

      <div className="container-x relative z-10 w-full py-16 md:py-24">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 bg-background-50/10 px-4 py-1.5 text-xs font-medium text-background-50 backdrop-blur">
            <i className="ri-flashlight-fill text-primary-300"></i>
            国产吃瓜视频 · 最新热点实时速递
          </span>
          <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 sm:text-4xl md:text-5xl">
            一网打尽全网
            <span className="text-primary-300">吃瓜热点</span>
            与八卦速递
          </h1>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-6 text-background-50/80 md:text-base">
            聚焦近期热门吃瓜事件与八卦汇总，持续更新视频内容。想看点最新、热点事件或完整汇总，收藏本站每日刷新即可。
          </p>

          <form onSubmit={onSearch} className="mx-auto mt-8 flex max-w-xl flex-col gap-2 sm:flex-row">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
              <input
                type="search"
                value={term}
                onChange={(e) => setTerm(e.target.value)}
                placeholder="搜索你想吃瓜的热点事件…"
                className="h-12 w-full rounded-md border border-background-200 bg-background-50 pl-11 pr-4 text-sm text-foreground-900 placeholder:text-foreground-400 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-300"
              />
            </div>
            <button
              type="submit"
              className="h-12 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              立即搜索
            </button>
          </form>

          <div className="mt-5 flex flex-wrap items-center justify-center gap-2">
            <span className="text-xs text-background-50/60">热门：</span>
            {hotTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => navigate(`/events?q=${encodeURIComponent(tag)}`)}
                className="rounded-full border border-background-50/25 bg-background-50/10 px-3 py-1 text-xs text-background-50/90 backdrop-blur transition-colors hover:border-primary-300 hover:bg-primary-500/40"
              >
                #{tag}
              </button>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-background-50/15 pt-6 text-center">
            <div>
              <p className="font-heading text-2xl font-bold text-primary-300 md:text-3xl">
                {events.length * 23}+
              </p>
              <p className="mt-1 text-xs text-background-50/65">热点视频栏目</p>
            </div>
            <div className="border-x border-background-50/15">
              <p className="font-heading text-2xl font-bold text-primary-300 md:text-3xl">5+</p>
              <p className="mt-1 text-xs text-background-50/65">八卦内容分类</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold text-primary-300 md:text-3xl">每日</p>
              <p className="mt-1 text-xs text-background-50/65">持续更新速递</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}